import Main from '@/views/administracion/configuracion/catalogos/usuarios/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/usuarios/Default.vue';
import MainUsuario from '@/views/administracion/configuracion/catalogos/usuarios/usuario/Main.vue';
import MainContratista from '@/views/administracion/configuracion/catalogos/usuarios/contratistas/Main.vue';
import DefaultUsuario from '@/views/administracion/configuracion/catalogos/usuarios/usuario/Default.vue';

// const auth = ['Seguridad:ver'];
const scopes = ['Seguridad:crear', 'Seguridad:editar', 'Seguridad:eliminar'];

const usuarios = [
  {
    path: 'usuarios',
    meta: {
      title: '',
      auth: [],
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoUsuarios',
        path: '/',
        meta: {
          title: 'Usuarios',
          auth: [],
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        name: 'catalogoUsuariosContratistas',
        path: 'contratistas',
        meta: {
          title: 'Catálogo de usuarios contratistas',
          auth: [],
          scopes,
        },
        component: MainContratista,
      },
      {
        path: ':id',
        meta: {
          title: 'Usuario',
          auth: [],
          scopes,
        },
        component: MainUsuario,
        children: [
          {
            name: 'usuario',
            path: '/',
            meta: {
              title: 'Usuario',
              auth: [],
              scopes,
            },
            component: DefaultUsuario,
          },
        ],
      },
    ],
  },
];

export default usuarios;
